module.exports = __webpack_public_path__ + "static/media/under-the-tree-1920.2b57a767.jpg";